import Container from '~/core/ui/Container';
import Heading from '~/core/ui/Heading';
import SubHeading from '~/core/ui/SubHeading';

import { Link } from '@remix-run/react';
import configuration from '~/configuration';

export const meta = () => {
  return [
    {
      title: `Terms of Use - ${configuration.site.siteName}`,
    },
  ];
};

function Terms() {
  return (
    <Container>
      <div className={'flex flex-col space-y-8 my-8'}>
        <div className={'flex flex-col items-center space-y-4'}>
          <Heading>Terms of Use</Heading>
          <SubHeading>Terms of Use for {configuration.site.name}</SubHeading>
        </div>
        <div className="p-8 rounded-lg ">
          <p className="mb-4">
            Last Updated:{' '}
            {new Date('10 / 21 / 2023').toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </p>

          <p className="mb-4">
            By using FaithGPT, you agree to the following terms and conditions.
          </p>

          <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
          <p className="mb-4">
            Please read these terms of use ("Terms") carefully. By accessing or
            using FaithGPT, you agree to be bound by these terms.
          </p>

          <h2 className="text-xl font-semibold mb-2">2. Changes to Terms</h2>
          <p className="mb-4">
            We may update or change these Terms at any time and recommend that
            you review the Terms on a regular basis.
          </p>

          <h2 className="text-xl font-semibold mb-2">
            3. User Responsibilities
          </h2>
          <p className="mb-4">
            You are responsible for your use of FaithGPT and any content you
            provide, including compliance with applicable laws.
          </p>

          <h2 className="text-xl font-semibold mb-2">4. Restrictions</h2>
          <p className="mb-4">
            You may not misuse our services, reproduce, or distribute the
            content without our permission. You may not attempt to reverse
            engineer or decompile FaithGPT. You may not use FaithGPT for any
            illegal or unauthorized purpose. You may not use FaithGPT to harass
            or abuse others.
          </p>

          <h2 className="text-xl font-semibold mb-2">5. Termination</h2>
          <p className="mb-4">
            We reserve the right to suspend or terminate your access to FaithGPT
            at any time.
          </p>

          <h2 className="text-xl font-semibold mb-2">6. Disclaimers</h2>
          <p className="mb-4">
            FaithGPT is provided "as is" without any warranties of any kind,
            either express or implied.
          </p>

          <h2 className="text-xl font-semibold mb-2">
            7. Limitation of Liability
          </h2>
          <p className="mb-4">
            To the maximum extent permitted by law, FaithGPT shall not be liable
            for any indirect, incidental, special, consequential, or punitive
            damages.
          </p>

          <h2 className="text-xl font-semibold mb-2">8. Governing Law</h2>
          <p className="mb-4">
            These terms are governed by and construed in accordance with the
            laws of British Columbia, Canada.
          </p>

          <h2 className="text-xl font-semibold mb-2">9. Contact</h2>
          <p className="mb-4">
            For any questions regarding these terms, please{' '}
            <Link to="/contact">contact us</Link>.
          </p>
        </div>
      </div>
    </Container>
  );
}

export default Terms;
